
import { TasksKeys } from '@/i18n/types';

export const tasks: Record<TasksKeys, string> = {
  addTask: 'Add Task',
  taskTitle: 'Task Title',
  taskDescription: 'Task Description',
  dueDate: 'Due Date',
  priority: 'Priority',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  status: 'Status',
  complete: 'Complete',
  incomplete: 'Incomplete',
  inProgress: 'In Progress',
  taskAdded: 'Task Added',
  taskUpdated: 'Task Updated',
  taskDeleted: 'Task Deleted',
  confirmDeleteTask: 'Confirm Delete Task',
  assign: 'Assign',
  taskDetails: 'Task Details',
  taskManagement: 'Task Management',
  taskDesc: 'Manage your tasks and use the Pomodoro technique to stay focused.',
  tasks: 'Tasks',
  taskStats: 'Task Statistics',
  gamification: 'Gamification',
  points: 'Points',
  streak: 'Streak',
  achievements: 'Achievements',
};
